<template>
	<BlockLayoutWrapper
		ref="blockLayout"
		:class="{
			'block-layout-provider-user--desktop-hidden': isDesktopBlockHidden,
			'block-layout-provider-user--mobile-hidden': isMobileBlockHidden
		}"
		:style="layoutCSSVars"
		:is-mobile-legacy="isMobileLegacy"
		is-block-responsive
	>
		<LayoutElementProviderUser
			v-for="element in layoutElements"
			:key="element.elementId"
			:is-mobile-legacy="isMobileLegacy"
			:element-id="element.elementId"
			:element-data="element"
			:lcp="lcp"
		/>
	</BlockLayoutWrapper>
</template>

<script>
import {
	toRefs,
	defineComponent,
	computed,
} from 'vue';

import BlockLayoutWrapper from '@zyro-inc/site-modules/components/blocks/layout/BlockLayoutWrapper.vue';
import { useBlockLayout } from '@zyro-inc/site-modules/components/blocks/layout/useBlockLayout';
import LayoutElementProviderUser from '@/components/layout-element/LayoutElementProviderUser.vue';

export default defineComponent({
	name: 'BlockLayoutProviderUser',

	components: {
		BlockLayoutWrapper,
		LayoutElementProviderUser,
	},

	props: {
		blockId: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
		components: {
			type: Object,
			default: () => ({}),
		},
		lcp: {
			type: Object,
			default: () => ({}),
		},
	},

	setup(props) {
		const { components: siteElements } = toRefs(props);

		const {
			layoutElements,
			layoutCSSVars,
			isMobileLegacy,
		} = useBlockLayout(props, siteElements);

		const isDesktopBlockHidden = computed(() => props.data.desktop?.isHidden || false);

		const isMobileBlockHidden = computed(() => props.data.mobile?.isHidden || false);

		return {
			layoutElements,
			isMobileLegacy,
			layoutCSSVars,
			isDesktopBlockHidden,
			isMobileBlockHidden,
		};
	},
});
</script>

<style lang="scss" scoped>
@import "@zyro-inc/site-modules/scss/mixins/site-engine-mobile";

.block-layout-provider-user {
	&--desktop-hidden {
		@media screen and (min-width: $media-mobile) {
			display: none;
		}
	}
}

@include site-engine-mobile {
	.block-layout-provider-user {
		&--mobile-hidden {
			display: none;
		}
	}
}
</style>
